import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  counter-increment: ", ";\n  display: flex;\n  list-style: none;\n  position: relative;\n  text-align: left;\n\n  &:active,\n  &:focus,\n  &:hover {\n    outline: none;\n  }\n\n  padding-bottom: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &:active,\n  &:focus,\n  &:hover {\n    outline: none;\n  }\n  &::before {\n    content: ", ";\n    font-weight: ", ";\n    margin-right: ", "px;\n    padding-right: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BodyConfig, MicroConfig, TypographyConfig } from '@vds-core/typography';
import { calculateRem } from '@uie/javascript-style-helpers';
import { withVDSManager } from '@vds-core/utilities';
import { calculateSpacing, colors } from '@vds-core/theme';

function _calculatePadding() {
  return calculateRem(6);
}

function _calculateBulletSpacing() {
  return calculateSpacing('4X');
}

var propTypes = {
  /**
   * Represents text within a ListItem.
   */
  children: PropTypes.node,

  /**
   * Determines the font size, line height, font family and font weight of the List item.
   */
  size: PropTypes.oneOf(['micro', 'bodySmall', 'bodyMedium', 'bodyLarge']),

  /**
   * Determines whether mobile, tablet, or desktop fontstacks are used. Desktop and tablet are the same size
   */
  viewport: PropTypes.oneOf(['mobile', 'tablet', 'desktop']),

  /**
   * If provided, used as string that labels the element for accessibility.
   */
  ariaLabel: PropTypes.string,

  /**
   * @ignore
   */
  orderedList: PropTypes.bool,

  /**
   * @ignore
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   */
  microConfig: PropTypes.object,

  /**
   * @ignore
   */
  calculatePadding: PropTypes.func,
  //this takes a size parameter and returns a value for spacing between each list item

  /**
   * @ignore
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   */
  calculateBulletSpacing: PropTypes.func,

  /**
   * @ignore
   */
  tabIndex: PropTypes.number,
  inverted: PropTypes.bool,
  colorConfig: PropTypes.object
};
var defaultProps = {
  bodyConfig: BodyConfig,
  microConfig: MicroConfig,
  orderedList: false,
  calculatePadding: _calculatePadding,
  size: 'bodyLarge',
  viewport: 'desktop',
  typescale: TypographyConfig.getTypescale(),
  calculateBulletSpacing: _calculateBulletSpacing,
  inverted: false,
  colorConfig: colors
};
var Glyph = /*#__PURE__*/styled.span.withConfig({
  displayName: "Glyph",
  componentId: "mxruz8-0"
})(_templateObject(), function (_ref) {
  var orderedList = _ref.orderedList;
  return orderedList ? 'counter(ol-counter) ". "' : "\"\u2022\"";
}, function (_ref2) {
  var size = _ref2.size;
  return size === 'bodyLarge' || size === 'bodySmall' ? 'bold' : 'normal';
}, function (_ref3) {
  var orderedList = _ref3.orderedList;
  return orderedList ? 5 : 0;
}, function (_ref4) {
  var orderedList = _ref4.orderedList,
      calculateBulletSpacing = _ref4.calculateBulletSpacing,
      size = _ref4.size;
  return orderedList ? 0 : calculateBulletSpacing(size);
});
var StyledLi = /*#__PURE__*/styled.li.withConfig({
  displayName: "StyledLi",
  componentId: "mxruz8-1"
})(_templateObject2(), function (_ref5) {
  var bodyConfig = _ref5.bodyConfig,
      getFontStyles = _ref5.getFontStyles,
      microConfig = _ref5.microConfig,
      size = _ref5.size,
      typescale = _ref5.typescale,
      viewport = _ref5.viewport;
  return getFontStyles(bodyConfig, microConfig, size, typescale, viewport);
}, function (_ref6) {
  var inverted = _ref6.inverted,
      colorConfig = _ref6.colorConfig;
  return inverted ? colorConfig.white : colorConfig.black;
}, function (_ref7) {
  var orderedList = _ref7.orderedList;
  return orderedList ? 'ol-counter' : 'none';
}, function (_ref8) {
  var calculatePadding = _ref8.calculatePadding,
      size = _ref8.size;
  return calculatePadding(size);
});
var ItemContainer = /*#__PURE__*/styled.span.withConfig({
  displayName: "ItemContainer",
  componentId: "mxruz8-2"
})(_templateObject3());

var ListItem = function ListItem(props) {
  var ariaLabel = props.ariaLabel,
      bodyConfig = props.bodyConfig,
      children = props.children,
      microConfig = props.microConfig,
      orderedList = props.orderedList,
      calculatePadding = props.calculatePadding,
      size = props.size,
      typescale = props.typescale,
      viewport = props.viewport,
      calculateBulletSpacing = props.calculateBulletSpacing,
      tabIndex = props.tabIndex,
      inverted = props.inverted,
      colorConfig = props.colorConfig,
      className = props.className;

  function _onClick(e) {
    if (e.type === 'click') e.target.blur();
  }

  function _getFontStack(bodyConfig, microConfig, size, typescale, TypographyConfig, viewport) {
    //Size = micro
    var MicroDesktop = microConfig.getStyles(typescale, 'desktop'); //Size = small

    var BodySmallDesktop = bodyConfig.getStyles(typescale, 'desktop', 'small');
    var BodySmallMobile = bodyConfig.getStyles(typescale, 'mobile', 'small'); //Size = medium

    var BodyMediumDesktop = bodyConfig.getStyles(typescale, 'desktop', 'medium');
    var BodyMediumMobile = bodyConfig.getStyles(typescale, 'mobile', 'medium'); //Size = large

    var BodyLargeDesktop = bodyConfig.getStyles(typescale, 'desktop', 'large');
    var BodyLargeMobile = bodyConfig.getStyles(typescale, 'mobile', 'large');
    var fontStack;
    var mobile = viewport === 'mobile';

    switch (size) {
      case 'micro':
        fontStack = MicroDesktop;
        break;

      case 'bodySmall':
        fontStack = mobile ? BodySmallMobile : BodySmallDesktop;
        break;

      case 'bodyMedium':
        fontStack = mobile ? BodyMediumMobile : BodyMediumDesktop;
        break;

      case 'bodyLarge':
      default:
        fontStack = mobile ? BodyLargeMobile : BodyLargeDesktop;
        break;
    }

    return fontStack;
  }

  function _getFontStyles() {
    var fontStack = _getFontStack(bodyConfig, microConfig, size, typescale, TypographyConfig, viewport);

    return "\n      font-family: ".concat(fontStack.fontFamily, ";\n      font-size: ").concat(calculateRem(fontStack.fontSize), ";\n      font-weight: normal;\n      line-height: ").concat(calculateRem(fontStack.lineHeight), ";\n      letter-spacing: ").concat(fontStack.letterSpacing && fontStack.letterSpacing, "px;\n    ");
  }

  return /*#__PURE__*/React.createElement(StyledLi, {
    "aria-label": ariaLabel,
    bodyConfig: bodyConfig,
    getFontStyles: _getFontStyles,
    microConfig: microConfig,
    onClick: _onClick,
    orderedList: orderedList,
    calculatePadding: calculatePadding,
    size: size,
    tabIndex: tabIndex,
    typescale: typescale,
    viewport: viewport,
    inverted: inverted,
    colorConfig: colorConfig,
    className: className
  }, /*#__PURE__*/React.createElement(Glyph, {
    size: size,
    calculateBulletSpacing: calculateBulletSpacing,
    "aria-hidden": true,
    tabIndex: -1
  }), /*#__PURE__*/React.createElement(ItemContainer, null, children));
};

ListItem.propTypes = propTypes;
ListItem.defaultProps = defaultProps;
ListItem.displayName = 'ListItem';
export default withVDSManager(ListItem);